import userUtils from './userUtils';

export function log(...args: unknown[]) {
	if (isDebugEnabled()) {
		console.debug(...formatMessage('#00a67c', args));
	}
}

export function info(...args: unknown[]) {
	if (isDebugEnabled()) {
		console.debug('🔍', ...formatMessage('#007bff', args));
	}
}

export function warn(...args: unknown[]) {
	if (isDebugEnabled()) {
		console.debug('⚠️', ...formatMessage('#ffc107', args));
	}
}

export function errLog(...args: unknown[]) {
	if (isDebugEnabled()) {
		console.debug('❌', ...formatMessage('#dc3545', args));
	}
}

export function success(...args: unknown[]) {
	if (isDebugEnabled()) {
		console.debug('✅', ...formatMessage('#28a745', args));
	}
}

function isDebugEnabled(): boolean {
	return userUtils.debugMode();
}

function formatMessage(color: string, args: unknown[]) {
	return ['%cAIQ', `color: ${color}`, ...args];
}
